var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwap = function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1.176-13.619-3.769.002-.084.006a.667.667 0 0 0-.582.661l.005.084a.667.667 0 0 0 .662.583l2.163-.002-4.992 4.992-.052.059a.667.667 0 0 0 .052.884l.058.052c.262.207.643.19.885-.052l4.989-4.989.001 2.161.005.084a.667.667 0 0 0 1.328-.085l-.002-3.773-.005-.084a.667.667 0 0 0-.662-.583Zm4.244 3.97-.058-.051a.667.667 0 0 0-.885.052L9.49 13.339l-.001-2.16-.006-.084a.667.667 0 0 0-1.328.084l.002 3.773.005.083a.667.667 0 0 0 .662.583l3.77-.002.083-.005a.667.667 0 0 0 .583-.662l-.006-.083a.667.667 0 0 0-.661-.583H10.43l4.989-4.989.052-.058a.667.667 0 0 0-.052-.884Z",
    fill: "#666"
  })));
};
export default SvgSwap;